import * as S from "./DaonSpinner.styles";

export default function DaonSpinner({ color, type, isDarkMode }) {
  return (
    <S.DaonSpinner color={color} type={type} darkBackground={isDarkMode}>
      <div />
    </S.DaonSpinner>
  );
}
